<style lang="less">
    @import "../../../styles/reset.less";
</style>
<template>
    <div class="container">
        <div class="progress_box">
            <Timeline :data="data"></Timeline>
            <div class="">
                <img class="now_state_icon" src="./images/auditing.png" alt="">
                <div class="now_state_msg">
                    <h3 class="now_state_title">审核中</h3>
                    <p class="now_state_text_group">
                        您申请的作品登记证书（电子版）已提交至版权局审核，审核周期为7～10个工作日，请耐心等待。如有任何疑问，请联系客服人员。</p>
                </div>
            </div>

        </div>

        <div class="details_main">
            <h3 class="page_title">作品登记证书（电子版）订单详情</h3>
            <ul class="details_group">
                <li class="details_item">
                    <h3 class="details_group_title">作品基本信息
                        <span class="title_right">下载作品文件</span>
                    </h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <span class="item_list_title">作品名称：</span><span class="item_list_content">下雪的山</span>
                            <span class="item_list_title">作品类型：</span><span class="item_list_content">照片</span>
                        </li>
                        <li class="details_content_item_list">
                            <span class="item_list_title">作&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;者：</span><span
                                class="item_list_content">王雪</span>
                            <span class="item_list_title">著作权人：</span><span>王雪</span>
                        </li>
                        <li class="details_content_item_list">
                            <span class="item_list_title">权利取得：</span><span class="item_list_content">原始取得</span>
                            <span class="item_list_title">权利归属：</span><span>个人作品</span>
                        </li>
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">作品创作信息</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <span class="item_list_title">创作开始时间：</span><span
                                class="item_list_content">2017-10-10</span>
                            <span class="item_list_title">创作完成时间：</span><span
                                class="item_list_content">2018-10-22</span>
                        </li>
                        <li class="details_content_item_list">
                            <span class="item_list_title">创作地点：</span><span class="item_list_content">中国-北京-北京</span>
                            <span class="item_list_title">修改次数：</span><span>3</span>
                        </li>
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">作品发表信息</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <span class="item_list_title">发表状态：</span><span class="item_list_content">2017-10-10</span>
                            <span class="item_list_title">首次发表时间：</span><span class="item_list_content">—</span>
                        </li>
                        <li class="details_content_item_list">
                            <span class="item_list_title">首次发表地点：</span><span class="item_list_content">中国-北京-北京</span>
                        </li>
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">创作意图</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p class="item_list_paragraph">
                                时间在变，发现自己越来越喜欢安静了，不去惊扰外面的喧嚣，也不刻意拨弄河边的青草。一个的时光里，浅浅地读一首诗，默默地赏一处金桂，秋风过处，眉宇间吐露欣喜，内心收获满满馨香。往事如烟，抽一段光阴，将过去的河山拾捡，人生聚散无常，将每一次的相遇放在眉间深藏，任凭落花飘零，风雨侵扰，仍不忘旧时模样。</p>
                        </li>
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">作品独创性</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p class="item_list_paragraph">
                                时间在变，发现自己越来越喜欢安静了，不去惊扰外面的喧嚣，也不刻意拨弄河边的青草。一个的时光里，浅浅地读一首诗，默默地赏一处金桂，秋风过处，眉宇间吐露欣喜，内心收获满满馨香。往事如烟，抽一段光阴，将过去的河山拾捡，人生聚散无常，将每一次的相遇放在眉间深藏，任凭落花飘零，风雨侵扰，仍不忘旧时模样。</p>
                        </li>
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">创作声明</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p>未经合法授权，任何单位和个人不得进行复制、转载、改编或其它侵权行为。</p>
                        </li>
                        <li class="details_content_item_list img_group">
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                            <div class="item_list_img">
                                <img src="" alt="">
                                <p class="item_list_desc">说明文件.doc</p>
                            </div>
                        </li>
                    </ol>
                </li>
            </ul>
        </div>

        <div class="details_footer">
            <div class="footer_btn">开始监测</div>
            <router-link class="jump_link" to="/">可前往“个人中心”查看审核情况</router-link>
        </div>
        <!-- <addDeComponent /> -->

    </div>

</template>

<script>
    import Timeline from '@/views/main-components/horizontal-timeline';
    import addDeComponent from './addDeComponent.vue';

    export default {
        name: "copyrightSuccess",
        components: {
            Timeline,
            addDeComponent
        },
        data () {
            return {
                data:[
                    {name:'选择作品',state:2},
                    {name:'完善信息',state:2},
                    {name:'信息审核',state:1},
                    {name:'颁发证书',state:0}
                ]
            }
        }

    }
</script>

<style scoped lang="less">
    /*************时间轴**********/
    .progress_box {
        margin: 0 auto;
        padding-top: 30px;
    }

    .progress_box .now_state_icon {
        width: 100px;
        height: 99px;
        margin: 70px auto 0;
        display: block;
    }

    .progress_box .now_state_msg {
        text-align: center;
        padding-top: 25px;
    }

    .now_state_msg .now_state_title {
        color: #666666;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
    }

    .now_state_msg .now_state_text_group {
        padding-top: 5px;
        width: 583px;
        text-align: center;
        color: #999999;
        font-size: 12px;
        line-height: 17px;
        margin: 0 auto;
        font-family: PingFangSC-Regular, PingFang SC;
    }

    .details_footer {
        text-align: center;
        padding: 30px 0 50px;
        border-top: 1px solid #F1F1F1;
        font-size: 14px;

    }

    .details_footer .footer_btn {
        width: 230px;
        height: 42px;
        line-height: 42px;
        border-radius: 4px;
        background: #FFD800;
        color: #4E4E4E;
        margin: 0 auto;
        cursor: pointer;
    }

    .details_footer .jump_link {
        color: #323232;
        text-decoration: underline;
        padding-top: 15px;
        display: block;

    }


    .copyrightDetails {
        margin: 20px 0 50px;
        background: #FDFDFD;
    }

    .page_title {
        color: #323232;
        background: #fff;
        box-shadow: 0 2px 18px 0 rgba(211, 214, 225, 0.15);
        border-radius: 8px 8px 0 0;
        height: 50px;
        font-size: 14px;
        line-height: 50px;
        padding-left: 20px;
    }

    .details_group {
        width: 100%;
        overflow: hidden;
    }

    .details_group .details_item:nth-child(odd) .details_content_item {
        background: #fcfcfc;
    }

    .details_group .details_item:last-child .details_content_item {
        background: #fff;
    }

    .details_group .details_group_title {
        color: #323232;
        height: 51px;
        line-height: 51px;
        background: #F8F8F8;
        font-size: 14px;
        padding-left: 20px;
        display: flex;
    }

    .details_group_title .title_right {
        margin-left: auto;
        padding-right: 30px;
        color: #FFA400;
        font-size: 14px;
        cursor: pointer;
    }

    .details_group .details_content_item {
        padding: 20px 40px;
        background: #fff;
    }

    .details_content_item .details_content_item_list {
        display: flex;
        padding-bottom: 20px;
    }

    .details_content_item .details_content_item_list.img_group {
        white-space: nowrap;
        overflow-x: scroll;
    }

    .details_content_item .details_content_item_list:last-child {
        padding-bottom: 0;
    }

    .details_content_item_list .item_list_title {
        width: 98px;
    }

    .details_content_item_list .item_list_content {
        width: 201px;
    }

    .details_content_item_list .item_list_paragraph {
        width: 690px;
        color: #666666;
        line-height: 20px;
        white-space: normal;
    }

    .details_content_item_list .item_list_img {
        margin-right: 30px;
        text-align: center;
    }

    .item_list_img img {
        display: block;
        width: 148px;
        height: 168px;
        box-shadow: 0 2px 18px 0 rgba(211, 214, 225, 0.24);
        border-radius: 6px;
        background: #f5f5f5;
        margin: 0 auto;
    }

    .item_list_img .item_list_desc {
        padding-top: 10px;
    }

    .details_content_item_list .item_list_content:last-child {
        flex: 1;
    }

    .details_content_item_list .cert_box {
        width: 485px;
        text-align: center;
    }

    .cert_box img {
        display: block;
        width: 485px;
        height: 340px;
        background: #f5f5f5;
    }

    .cert_box .download_btn {
        width: 214px;
        height: 40px;
        line-height: 40px;
        background: #FFD800;
        border-radius: 21px;
        color: #4E4E4E;
        font-size: 14px;
        margin: 20px auto 0;
        cursor: pointer;
    }


</style>